import type { MouseEvent } from 'react'
import { Mic } from 'lucide-react'
import { Button, Tooltip } from '@highlight/ui'
import { useIncognitoMode } from '@renderer/hooks/useIncognitoMode'
import { useStartMiniMeeting } from './use-start-mini-meeting'

/** The notched bar's 28px button, or in the expanded pill Button's own square to match the logo. */
export function MiniNewMeetingButton({ inPill = false }: { inPill?: boolean }) {
  const startMeeting = useStartMiniMeeting()
  const { isIncognitoEnabled } = useIncognitoMode()

  const handleClick = (event: MouseEvent) => {
    event.stopPropagation()
    startMeeting()
  }

  return (
    <Tooltip>
      {/* A disabled button gets no pointer events, so the wrapper keeps the tooltip reachable */}
      <Tooltip.Trigger render={<div className="relative flex" />}>
        <Button
          variant="ghost"
          size={inPill ? 'sm' : 'md'}
          shape="square"
          aria-label="New meeting note"
          disabled={isIncognitoEnabled}
          onClick={handleClick}
        >
          <Mic aria-hidden="true" className="size-4" />
        </Button>
      </Tooltip.Trigger>
      <Tooltip.Content sideOffset={14}>
        {isIncognitoEnabled ? 'Turn off incognito mode to start transcribing' : 'New meeting note'}
      </Tooltip.Content>
    </Tooltip>
  )
}
